import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './dashboard.scss';
import user from '../../images/contactAgent1.jpg';
// import { ReactComponent as Award } from '../../images/award.svg';
import Donut from '../../components/Donut/Donut';
import Modal from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';
import useTargets from '../../hooks/useTargets';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux';
import { Loader, RingProgress, Text } from '@mantine/core';
import { Box, Grid } from '@mui/material';
import { formatNumber } from '../../utils/functions';
// import useFetch from '../../hooks/useFetch';
// import { useSelector } from 'react-redux';

function Dashboard() {
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  // const teamId = useSelector((state) => state.auth.marketerDetails.team_id);

  return (
    <>
      <Modal style={{ minWidth: 'unset' }} open={detailsModalOpen} onClose={() => setDetailsModalOpen(false)}>
        <div className="dashboard-modal">
          <h3>team bonus</h3>
          <p>
            A team needs a minimum of <b>10 BPO Farm Agent orders</b> per Marketing Executive to qualify for a bonus.
            The team gets a payout of <b>10%</b> of the months total profit <b>(BPO Farm Agent Setup fees)</b>
          </p>
          <div className="dashboard-modal_middler">
            <span>Your team’s status :</span>
            <p>Qualified</p>
          </div>
          <h3>BONUS SPLIT</h3>
          <p>
            The team’s bonus would be split based on each Marketing Executive’s performance; the number of subscriptions
            they had.
          </p>
          <div>
            <div className="dashboard-modal_deets">
              <div>
                <span>Team Bonus</span>
                <p>$1,200</p>
              </div>
              <div>
                <span>Number of BPO Farm Agent Orders</span>
                <p>$1,200</p>
              </div>
              <div>
                <span>Team Bonus</span>
                <p>$1,200</p>
              </div>
            </div>
          </div>
          <Button
            style={{
              width: 'fit-content',
              fontSize: '16px',
              padding: '10px 60px',
              color: 'var(--primary-color)',
              backgroundColor: 'white',
              display: 'block',
            }}
            text="Split Bonus"
          />
          <div className="dashboard-modal__table">
            <table>
              <thead>
                <tr>
                  <th scope="column">Team Members</th>
                  <th scope="column">No. Of Orders</th>
                  <th scope="column">% Share</th>
                  <th scope="column">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <img src={user} alt="user" className="user" />
                    <span>Mkt. Exe Name</span>
                  </td>
                  <td>34</td>
                  <td>22.97&nbsp;&nbsp;&nbsp;%</td>
                  <td>245.89</td>
                </tr>
                <tr>
                  <td>
                    <img src={user} alt="user" className="user" />
                    <span>Mkt. Exe Name</span>
                  </td>
                  <td>34</td>
                  <td>22.97&nbsp;&nbsp;&nbsp;%</td>
                  <td>245.89</td>
                </tr>
                <tr>
                  <td>
                    <img src={user} alt="user" className="user" />
                    <span>Mkt. Exe Name</span>
                  </td>
                  <td>34</td>
                  <td>22.97&nbsp;&nbsp;&nbsp;%</td>
                  <td>245.89</td>
                </tr>
                <tr>
                  <td>
                    <img src={user} alt="user" className="user" />
                    <span>Mkt. Exe Name</span>
                  </td>
                  <td>34</td>
                  <td>22.97&nbsp;&nbsp;&nbsp;%</td>
                  <td>245.89</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
      <div className="dashboard-exec">
        {/* <div className="topex">
          <p>Top 3 Marketing Executives of the week</p>
          <span>This Week</span>
          <div className="top">
            <div>
              <img src={user} alt="user" className="avatar-user" />
              <div className="top-content">
                <div className="elements">
                  <Award />
                  <span style={{ color: '#FFF84A' }}>162 pts</span>
                </div>
                <p>Nathan Walker</p>
              </div>
            </div>
            <div>
              <img src={user} alt="user" className="avatar-user" />
              <div className="top-content">
                <div className="elements">
                  <Award
                  // style={{
                  // 	'--whiteA': 'rgb(255, 255, 255)',
                  // 	'--whiteB': 'rgb(224, 224, 224)',
                  // }}
                  />
                  <span style={{ color: 'white' }}>158 pts</span>
                </div>
                <p>Nathan Walker</p>
              </div>
            </div>
            <div>
              <img src={user} alt="user" className="avatar-user" />
              <div className="top-content">
                <div className="elements">
                  <Award />
                  <span style={{ color: '#FBBC05' }}>152 pts</span>
                </div>
                <p>Nathan Walker</p>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="ranks">
          <p>today’s activity</p>
          <table>
            <thead>
              <tr>
                <th>Marketing Agents</th>
                <th>Calls</th>
                <th>Latest Call</th>
                <th>Deals</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>John Desire walker</td>
                <td>3</td>
                <td>12/02/2022, 8:30 pm</td>
                <td>1</td>
                <td>$ 200</td>
              </tr>
              <tr>
                <td>Whoopie Goldberg</td>
                <td>3</td>
                <td>12/02/2022, 8:30 pm</td>
                <td>1</td>
                <td>$ 200</td>
              </tr>
              <tr>
                <td>Lara Croft</td>
                <td>3</td>
                <td>12/02/2022, 8:30 pm</td>
                <td>1</td>
                <td>$ 200</td>
              </tr>
              <tr>
                <td>JJofj</td>
                <td>3</td>
                <td>12/02/2022, 8:30 pm</td>
                <td>1</td>
                <td>$ 200</td>
              </tr>
              <tr>
                <td>JJofj</td>
                <td>3</td>
                <td>12/02/2022, 8:30 pm</td>
                <td>1</td>
                <td>$ 200</td>
              </tr>
            </tbody>
          </table>
        </div> */}
        <div className="hold">
          <div>
            <p>sales value</p>
            <div>
              <Donuter type="Month" />
              <Donuter type="Year" />
            </div>
          </div>
          <div className="right">
            {/* <div>
              <p>This month</p>
              <table>
                <thead>
                  <tr>
                    <th>Marketing Agents</th>
                    <th>Subscription</th>
                    <th>Points</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>John Desire walker</td>
                    <td>3</td>
                    <td>3</td>
                    <td>$ 200</td>
                  </tr>
                  <tr>
                    <td>John Desire walker</td>
                    <td>3</td>
                    <td>3</td>
                    <td>$ 200</td>
                  </tr>
                  <tr>
                    <td>John Desire walker</td>
                    <td>3</td>
                    <td>3</td>
                    <td>$ 200</td>
                  </tr>
                  <tr>
                    <td>John Desire walker</td>
                    <td>3</td>
                    <td>3</td>
                    <td>$ 200</td>
                  </tr>
                  <tr>
                    <td>John Desire walker</td>
                    <td>3</td>
                    <td>3</td>
                    <td>$ 200</td>
                  </tr>
                  <tr>
                    <td>Whoopie Goldberg</td>
                    <td>3</td>
                    <td>3</td>
                    <td>$ 200</td>
                  </tr>
                  <tr>
                    <td>Whoopie Goldberg</td>
                    <td>3</td>
                    <td>3</td>
                    <td>$ 200</td>
                  </tr>
                  <tr>
                    <td>Whoopie Goldberg</td>
                    <td>3</td>
                    <td>3</td>
                    <td>$ 200</td>
                  </tr>
                  <tr>
                    <td>Whoopie Goldberg</td>
                    <td>3</td>
                    <td>3</td>
                    <td>$ 200</td>
                  </tr>
                  <tr>
                    <td>Lara Croft</td>
                    <td>3</td>
                    <td>3</td>
                    <td>$ 200</td>
                  </tr>
                  <tr>
                    <td>JJofj</td>
                    <td>3</td>
                    <td>3</td>
                    <td>$ 200</td>
                  </tr>
                  <tr>
                    <td>JJofj</td>
                    <td>3</td>
                    <td>3</td>
                    <td>$ 200</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="db_nav">
              <Grapher />
              <ThisWeek />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;

const subs = [
  {
    name: 'BPO Farm Agent',
    key: 'bpo_farm',
    path: '/sub/bpo-farm',
  },
  {
    name: 'Premier Agent',
    key: 'premier_agent_website',
    path: '/sub/premier-agent-website',
  },
  {
    name: 'Deal Analyzer',
    key: 'deal_analyzer',
    path: '/sub/deal-analyzer',
  },
  {
    name: 'Combo Package',
    key: 'combo_package',
    path: '/sub/combo-package',
  },
];

const ThisWeek = () => {
  const id = useSelector((state) => state.auth.marketerDetails.id);
  const { isLoading, data } = useFetch(
    `compensations/snr-marketers-compensation-package-count/?snr_marketer_id=${id}&year=${new Date().getFullYear()}&month=${
      new Date().getMonth() + 1
    }`
  );

  if (isLoading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }
  return (
    <div>
      <p>This month</p>
      {data &&
        subs.map((item, index) => (
          <NavLink to={item.path} key={item.key}>
            <span>{item.name} Subscriptions</span>
            <span>{data?.[item.key] || 0}</span>
          </NavLink>
        ))}
    </div>
  );
};

/**
 *
 * @param {'Month'|'Year' } type
 * @returns
 */
const Donuter = ({ type }) => {
  const { isLoading, selectedMonth, selectedYear } = useTargets();
  const id = useSelector((state) => state.auth.marketerDetails.id);
  let url = `/compensations/snr-marketers-compensation-amount-view/?snr_marketer_id=${id}&year=${new Date().getFullYear()}`;
  if (type === 'Month') {
    url += `&month=${new Date().getMonth() + 1}`;
  }
  const { data, isLoading: isLoadingAmount } = useFetch(url);
  if (isLoading || isLoadingAmount) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader color="dark" />
      </div>
    );
  }

  return (
    <div>
      <p>{type}</p>
      <span>Current {type}</span>
      <Donut
        total={{ ...(type === 'Month' ? selectedMonth : selectedYear) }?.amount_per_team || 0}
        current={data?.package_amount || 0}
      />
    </div>
  );
};

const colors = {
  'bpo-farm': '#2d8cff',
  'premier-agent-website': '#fbbc05',
  'deal-analyzer': '#eb3f5e',
  'combo-package': '#00c853',
};

const Grapher = () => {
  const { isLoading, selectedYear, selectedMonth } = useTargets();

  if (isLoading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center">
        <Loader />
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xl={12} textAlign="center" color="var(--primary-color)" fontSize="18px">
        Sales Targets
      </Grid>
      <Grid item xl={6} textAlign="center">
        Year
      </Grid>
      <Grid item xl={6} textAlign="center">
        Month
      </Grid>
      <Grid item xl={6} display="flex" justifyContent="center">
        <RingProgress
          size={300}
          thickness={25}
          label={
            <Text size="20px" align="center" px="xs" sx={{ pointerEvents: 'none', fontWeight: 500 }}>
              $ {formatNumber(selectedYear?.amount_per_team || 0)}
            </Text>
          }
          sections={
            selectedYear?.sub_targets?.map((sub) => ({
              value: (sub?.amount_per_team / selectedYear.amount_per_team) * 100,
              color: colors[sub?.package_name],
              tooltip: `${sub?.package_name?.split('-').join(' ')} -$ ${formatNumber(sub?.amount_per_team)} `,
            })) || []
          }
        />
      </Grid>
      <Grid item xl={6} display="flex" justifyContent="center">
        <RingProgress
          size={300}
          thickness={25}
          label={
            <Text size="20px" align="center" px="xs" sx={{ pointerEvents: 'none', fontWeight: 500 }}>
              $ {formatNumber(selectedMonth?.amount_per_team || 0)}
            </Text>
          }
          sections={
            selectedMonth?.sub_targets?.map((sub) => ({
              value: (sub?.amount_per_team / selectedMonth.amount_per_team) * 100,
              color: colors[sub?.package_name],
              tooltip: `${sub?.package_name?.split('-').join(' ')} -$ ${formatNumber(sub?.amount_per_team)} `,
            })) || []
          }
        />
      </Grid>
    </Grid>
  );
};
